import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { Accordion, HTMLParser, IAccordionItem, PageHeader, PageSection, StartInkindCard } from '@gik/ui';
import MarketingNavSection from '../../components/MarketingNav/MarketingNavSection';
import { translationKeys } from './i18n/en';
import { useTranslation } from 'react-i18next';
import TestimonialsCarouselSection from '@gik/ui/gik/TestimonialsCarouselSection';
import { CreateClickedLocation } from '@gik/create/hooks/useCreateAnalytics';
import { FAQStructuredData } from '@gik/seo';
import { useFaq } from '@gik/api/acf/gik-settings/faq';
import { WordpressFAQItem } from '@gik/core/models/wordpress/WordpressFAQItem';

function removeParagraph(title: string): string {
  title = title.trim();
  if (title.startsWith('<p>') && title.endsWith('</p>')) {
    title = title.substring('<p>'.length, title.length - '</p>'.length);
  }
  return title;
}

function createAccordionItems(faqItems: WordpressFAQItem[]): IAccordionItem[] {
  return faqItems?.map(item => ({
    title: HTMLParser({ rawHtml: removeParagraph(item.question) }),
    content: HTMLParser({ rawHtml: item.answer }),
  }));
}

export const CommonQuestionsPageBlockName = 'common-questions-page';

export default function CommonQuestionsPage(): React.ReactElement {
  const bem = bemBlock(CommonQuestionsPageBlockName);
  const { t } = useTranslation();

  const { data: faq } = useFaq();

  const FAQItems: IAccordionItem[] = React.useMemo(() => createAccordionItems(faq?.faq), [faq]);

  return (
    <FAQStructuredData>
      <article className={bem()}>
        <PageHeader variant="sage" decoration="foliage">
          <h1>{t(translationKeys.title)}</h1>
        </PageHeader>

        <PageSection className={bem('lead')} noPadBottom>
          <p className="gik-section-lead">{t(translationKeys.leadDescription)}</p>
        </PageSection>

        <PageSection>
          <Accordion items={FAQItems} headingLevel={2} dividers />
        </PageSection>

        <StartInkindCard trackingId={CreateClickedLocation.FAQ_PAGE} />

        <TestimonialsCarouselSection />

        <MarketingNavSection variant="sage" />
      </article>
    </FAQStructuredData>
  );
}
